


















































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyForm from "@/mixins/form";

@Component
export default class extends Mixins(MyForm) {
  handleSubmit() {
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.$confirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            this.confirmLoading = true;
            const res = await this.$store.dispatch("sms/edittpl", {
              id: this.editId,
              ...values
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);
              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          }
        });
      }
    });
  }

  async mounted() {
    this.spinLoading = true;
    const res = await this.$store.dispatch("sms/tpldetail", {
      id: this.editId
    });
    if (res && res.Data && res.Data !== "{}") {
      this.formData = res.Data;
    }
    this.spinLoading = false;
  }
}
